import * as React from 'react';
import classNames from 'classnames';
import { UIText1, UIText2, ArticleHeading2 } from '@cian/ui-kit';

import { formatMoney } from '../../../../../../../../utils/string';
import { NBSP } from '../../../../../../../../constants/symbols';
import fireIconSrc from './assets/fire.svg';
import * as styles from './RecommendedPackage.css';

interface IProps {
  isMobile: boolean;
  headerText: string;
  content: React.ReactNode;
  discountPercent: number;
  marketingPrice: number;
  packagePrice: number;
  pricePerOffer: number;
  handleClick(): void;
}

export const RecommendedPackage = ({
  isMobile,
  headerText,
  content,
  discountPercent,
  marketingPrice,
  packagePrice,
  pricePerOffer,
  handleClick,
}: IProps) => (
  <div
    data-testid="recommendedPackage"
    className={classNames(styles['wrapper'], isMobile && styles['mobile'])}
    onClick={handleClick}
  >
    <div className={styles['text']}>
      <div className={styles['title']}>
        <UIText1 fontWeight="bold">{headerText}</UIText1>
      </div>

      {content}
    </div>

    <div className={styles['prices']}>
      <div className={styles['marketing-block']}>
        <div className={styles['discount-label']}>
          <img src={fireIconSrc} />
          {NBSP}-{discountPercent}%
        </div>

        <div className={styles['package-price']}>
          <div className={styles['marketing-price']}>
            <UIText2 color="black_60">{formatMoney(marketingPrice)}</UIText2>
          </div>

          <UIText2>{formatMoney(packagePrice)}</UIText2>
        </div>
      </div>

      {!!pricePerOffer && (
        <div className={styles['price-per-offer']}>
          <div className={styles['price']}>
            <ArticleHeading2>{formatMoney(pricePerOffer)}</ArticleHeading2>
          </div>

          <UIText2>за объявление</UIText2>
        </div>
      )}
    </div>
  </div>
);
